module.exports = __webpack_public_path__ + "img/Card.94443413.svg";